export default {
  methods: {
    showSnack: function (result) {
      if (result) {
        this.$store.commit(
          'snackBar/addMessage',
          result
        )
      }
    },

    showSnackAndMove: function (result) {
      if (result) {
        this.$store.commit(
          'snackBar/addMessage',
          result
        )

        this.$router.go(-1)
      }
    }
  }
}
